"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconChatIdFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconChatIdFilled = function SvgIconChatIdFilled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18028 1.7874C6.31342 1.2514 5.99124 0.692567 5.46067 0.539205C4.93011 0.385843 4.39207 0.696031 4.25894 1.23203L3.81979 3.00004L2.5 3.00004C1.94771 3.00004 1.5 3.44776 1.5 4.00004C1.5 4.55233 1.94771 5.00004 2.5 5.00004H3.32302L2.82625 7.00004H1.45233C0.900046 7.00004 0.452332 7.44776 0.452332 8.00004C0.452332 8.55233 0.900046 9.00004 1.45233 9.00004H2.32948L2.02963 10.2073C1.89649 10.7433 2.21868 11.3021 2.74924 11.4555C3.2798 11.6088 3.81784 11.2986 3.95097 10.7626L4.38877 9.00004L6.32948 9.00004L6.02963 10.2073C5.89649 10.7433 6.21868 11.3021 6.74924 11.4555C7.2798 11.6088 7.81784 11.2986 7.95097 10.7626L8.38877 9.00004H9.45233C10.0046 9.00004 10.4523 8.55233 10.4523 8.00004C10.4523 7.44776 10.0046 7.00004 9.45233 7.00004H8.88554L9.38231 5.00004H10.5C11.0523 5.00004 11.5 4.55233 11.5 4.00004C11.5 3.44776 11.0523 3.00004 10.5 3.00004H9.87908L10.1803 1.7874C10.3134 1.2514 9.99124 0.692567 9.46067 0.539205C8.93011 0.385843 8.39207 0.696031 8.25894 1.23203L7.81979 3.00004L5.87908 3.00004L6.18028 1.7874ZM5.38231 5.00004L4.88554 7.00004H6.82625L7.32302 5.00004H5.38231Z",
    fill: "currentColor"
  }));
};

exports.SvgIconChatIdFilled = SvgIconChatIdFilled;